import { useState } from 'react';
import { ArrowUpRight } from 'lucide-react';

export default function VisualLinkCard({ image, eyebrow, title, description, onClick, className = '' }) {
  const [imageFailed, setImageFailed] = useState(false);

  const classNames = `group relative block w-full min-h-[218px] overflow-hidden rounded-[24px] border border-black/[0.07] bg-[#ded9ce] text-left shadow-[0_24px_60px_-42px_rgba(54,45,36,.55)] transition duration-300 dark:border-white/[0.08] dark:bg-[#242127] ${
    onClick ? 'hover:-translate-y-1 hover:shadow-[0_28px_64px_-36px_rgba(54,45,36,.58)]' : ''
  } ${className}`;

  const content = (
    <>
      {!imageFailed ? (
        <img
          src={image}
          alt=""
          className={`absolute inset-0 h-full w-full object-cover transition duration-700 ${onClick ? 'group-hover:scale-[1.025]' : ''}`}
          onError={() => setImageFailed(true)}
        />
      ) : (
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_75%_15%,rgba(185,167,231,.55),transparent_38%),linear-gradient(135deg,#ddd7ca,#98909f)]" />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#18151b]/88 via-[#18151b]/15 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 flex items-end justify-between gap-4 p-5 text-white">
        <div className="min-w-0">
          <p className="mb-1.5 text-[10px] font-semibold uppercase tracking-[0.18em] text-white/62">{eyebrow}</p>
          <h3 className="text-[18px] font-semibold tracking-[-0.02em]">{title}</h3>
          <p className="mt-1 max-w-[28rem] text-[12px] leading-5 text-white/66">{description}</p>
        </div>
        {onClick && (
          <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white transition group-hover:border-white/35 group-hover:bg-white/20">
            <ArrowUpRight size={16} />
          </span>
        )}
      </div>
    </>
  );

  if (!onClick) return <article className={classNames}>{content}</article>;

  return (
    <button type="button" onClick={onClick} className={classNames}>
      {content}
    </button>
  );
}
